import { useState, useEffect } from "react";
import AddressList from "./AddressList";
import AddressAddForm from "./AddressAddForm";
import AddressEditForm from "./AddressEditForm";
import {
  fetchAddressTypes,
  fetchAddressByUserId
} from "../../../services/addressApi/addressApi";

export default function Address({ onSelectAddress }) {
  const [address, setAddress] = useState([]);
  const [addressTypes, setAddressTypes] = useState([]);
  const [editData, setEditData] = useState(null);
  const [showAdd, setShowAdd] = useState(false);
  const [selected, setSelected] = useState(null);

  const user = JSON.parse(localStorage.getItem("medarphaUser"));
  const userId = user?.id || user?.userId;

  useEffect(() => {
    loadAddresses();
  }, []);

  async function loadAddresses() {
    const types = await fetchAddressTypes();
    setAddressTypes(Array.isArray(types?.data) ? types.data : types);

    const list = await fetchAddressByUserId(userId);
    setAddress(Array.isArray(list?.data) ? list.data : list);
  }

  // ✅ SELECT ADDRESS
  const handleSelect = (item) => {
    const fullAddress = [
      item.faltHousNumber,
      item.street,
      item.locality,
      item.pincode,
    ]
      .filter(Boolean)
      .join(", ");

    setSelected(item.id);
    localStorage.setItem("selectedAddress", fullAddress);

    if (onSelectAddress) {
      onSelectAddress(fullAddress);
    }
  };

  return (
    <div style={{ fontFamily: "sans-serif" }}>

      {/* ── HEADER + ADD BUTTON ── */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <span style={{ fontSize: 18 }}>📍</span>
          <h4 className="m-0 text-base font-bold" style={{ color: "#111827" }}>
            My Addresses
          </h4>
        </div>

        <button
          onClick={() => {
            setShowAdd(true);
            setEditData(null); // ✅ edit form band
          }}
          style={{
            backgroundColor: "#dc2626",
            color: "#ffffff",
            fontSize: 13,
            fontWeight: 600,
            padding: "8px 18px",
            border: "none",
            borderRadius: 8,
            cursor: "pointer",
          }}
        >
          + Add New Address
        </button>
      </div>

      {/* ── ADD FORM — showAdd true ho aur editData null ho tab dikhao ── */}
      {showAdd && !editData && (
        <div style={{ marginBottom: 20 }}>
          <AddressAddForm
            userId={userId}
            addressTypes={addressTypes}
            onSuccess={() => {
              loadAddresses();
              setShowAdd(false);
            }}
            onCancel={() => setShowAdd(false)}
          />
        </div>
      )}

      {/* ── EDIT FORM — editData ho tab dikhao, Add form apne aap hide ── */}
      {editData && (
        <div style={{ marginBottom: 20 }}>
          <AddressEditForm
            data={editData}
            addressTypes={addressTypes}
            onSuccess={() => {
              loadAddresses();
              setEditData(null);
            }}
            onCancel={() => setEditData(null)}
          />
        </div>
      )}

      {/* ── ADDRESS LIST ── */}
      <AddressList
        list={address}
        onEdit={(item) => {
          setEditData(item);
          setShowAdd(false); // ✅ Add form hide ho jaye jab edit click ho
        }}
        onRefresh={loadAddresses}
        onSelect={handleSelect}
      />

    </div>
  );
}